import React from 'react'
import PropTypes from 'prop-types'
import RessourcenPlanungGridItem from '#components/a/RessourcenPlanungGridItem'

export function RessourcenPlanungRow({ressourcenOfAbteilung}) {
  const findRessourceWithStartInMonth = (ressourcen, month) => ressourcen.find(ressource => ressource.from === month)
  const items = []
  for (let i = 0; i < 12; i++) {
    const ressourceWithStartInMonth = findRessourceWithStartInMonth(ressourcenOfAbteilung.ressourcen, i + 1)
    items.push(<RessourcenPlanungGridItem key={i} ressource={ressourceWithStartInMonth} month={i} />)
  }
  const abteilungStyle = {borderLeftColor: ressourcenOfAbteilung.backgroundColor}
  const backgroundStyle = {backgroundColor: ressourcenOfAbteilung.backgroundColor}
  return (
    <div className="ressourcenPlanungRow" data-testid="ressourcenplanung-row">
      <div className="ressourcenPlanungAbteilung" style={abteilungStyle}>
        <div className="ressourcenPlanungAbteilungBackground" style={backgroundStyle} />
        <div className="ressourcenPlanungAbteilungText">{ressourcenOfAbteilung.name}</div>
      </div>
      {items}
    </div>
  )
}

RessourcenPlanungRow.propTypes = {
  ressourcenOfAbteilung: PropTypes.object,
}

export default RessourcenPlanungRow
